import type { BoxProps} from '@chakra-ui/react'
import { Box, Image, Spinner } from '@chakra-ui/react'

import { useGetBrandLogo } from '@/hooks/useDocuments'

import car from '../images/apps/car.svg'
const logoSize = 44
export interface VehicleLogoProps extends BoxProps {
  druh?: number | null
  znacka?: string | null
}
export const VehicleLogo = ({ druh, znacka, ...rest }: VehicleLogoProps) => {
  const { data: dataLogo, isLoading: isLoadingLogo, isError: isErrorLogo } = useGetBrandLogo(druh, znacka)

  if (isLoadingLogo)
    return <Box {...rest}><Spinner /></Box>

  if (isErrorLogo)
    return <Image src={car} {...rest} />

  return (<Image
    src={'data:image/png;base64,' + dataLogo?.data}
    alt={znacka ?? undefined}
    sx={{
      width: {
        base: 12,
        md: `${logoSize}px`,
      },
      height: {
        base: 12,
        md: `${logoSize}px`,
      },
      minWidth: {
        base: 12,
        md: `${logoSize}px`,
      },
      minHeight: {
        base: 12,
        md: `${logoSize}px`,
      },
      transition: 'all 200ms ease-in-out',
    }}
    filter="drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.15))"
    {...rest}
  />
  )
}